module.exports = __webpack_public_path__ + "img/volume-filled-icon.cc1fb599.svg";